<template>
    <div class="flex flex-wrap pt-3 pb-3 lg:pb-1 px-4 border border-gray-200 my-5">
        <div class="w-full md:w-1/2 lg:w-3/5" v-if="loading">
            <spinner></spinner>
        </div>

        <div class="w-full md:w-1/2 lg:w-3/5 flex flex-wrap print:w-1/2" v-else>
            <div class="pb-2 w-full border-b border-dotted border-gray-200">
                <h2 class="text-lg font-bold leading-tight">Underlying Futures Price for {{ `${quotes.symbolName} Options` }}</h2>
                <button-group class="inline print:hidden"
                    :symbol="quotes.symbol"
                    :groups="['C','F']">
                </button-group>
            </div>
            <div class="w-full lg:w-1/2 print:w-1/2">
                <div class="mr-3">
                    <div class="border-b border-dotted border-gray-200 py-1">
                         <span class="font-semibold text-base mr-1">{{ `${quotes.contractMonthYear}` }}:</span> {{ quotes.lastPrice }}
                    </div>
                    <div class="border-b border-dotted border-gray-200 lg:border-white py-1">
                        <span class="font-semibold text-base mr-1">Settlement:</span>
                        <span class="text-base text-red-500" v-if="isPastOptionsExpiration(quotes.optionsExpiration)">
                            {{ quotes.optionsExpiration }}
                        </span>
                        <span class="text-base" v-else>
                            {{ quotes.optionsExpiration }} ({{ quotes.daysToExpiration }} {{ pluralize('Day', quotes.daysToExpiration) }} left)
                        </span>
                    </div>
                </div>
            </div>
            <div class="w-full lg:w-1/2 print:w-1/2">
                <div class="border-b border-dotted border-gray-200 py-1">
                    <span class="font-semibold text-base mr-1">Price Value of Option Point:</span>
                    <span class="text-base">{{ quotes.pointValue }}</span>
                </div>
                <div class="border-b border-dotted border-gray-200 md:border-white py-1 mb-4">
                    <span class="font-semibold text-base mr-1">Implied Volatility:</span>
                    <span class="text-base">{{ quotes.impliedVolatility }}</span>
                </div>
            </div>
        </div>
        <div class="w-full md:w-1/2 lg:w-2/5 print:w-1/2">
            <mini-chart-widget v-if="rMiniChart"
                :symbol="rMiniChart.symbol"
                :title="rMiniChart.title">
            </mini-chart-widget>
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted, watch } from 'vue';

const props = defineProps({
    miniChart: Object,
    quotes: Object,
    loading: Boolean
});

const rMiniChart = ref(null);

const pluralize = (word, count) => {
    return count === 1 ? word : word + 's';
}

const isPastOptionsExpiration = (optionsExpiration) => {
    if (optionsExpiration) {
        if (new Date(optionsExpiration) < new Date()) {
            return true;
        }
    }
    return false;
}

watch(() => props.miniChart, () => {
    if (props.miniChart) {
        rMiniChart.value = props.miniChart;
    }
});
</script>
